import React, { useState } from 'react';
import { Button, Label, Input, Card, CardBody, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import Loading from '../../Components/Loading/Loading';

import Logic from '../../Logic';

function Sms(props){
    const [identityNumber, setIdentityNumber] = useState('');
    const [mobilePhone, setMobilePhone] = useState('');
    const [smsCode, setSmsCode] = useState('');
    const [error, setError] = useState(null);
    const [shouldHaveSmsCode, setShouldHaveSmsCode] = useState(false);   
    const [smsSentNotification, setSmsSentNotification] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);

    function validate(){
        let logic = new Logic();
        if(props.init.candidate.identityNumber !== identityNumber || props.init.candidate.mobilePhone !== mobilePhone){
            alert('מספר תעודת הזהות או מספר הטלפון הסלולרי אינם תואמים את פרטי המועמד');
            return;
        }

        if(!shouldHaveSmsCode){
            resend();
        }else{
            setShowSpinner(true);
            
            if(identityNumber.length !== 9){
                setIdentityNumber(logic.pad(identityNumber, 9, '0'))
            } 
            
            logic.validateSms(identityNumber, mobilePhone, smsCode, (res) => {
                setShowSpinner(false);
                if(!res.success){
                    alert(res.message);
                    return;
                }
                if(res.data.candidate){
                    props.onAuthenticated(res.data, { validSms: true, errorMessage: res.message, unknown: false });
                    props.history.push('/edit');
                }else{
                    alert(res.message);
                }
             });
        }
    }

    function resend(){
        let logic = new Logic();
        if(identityNumber.length !== 9){
            setIdentityNumber(logic.pad(identityNumber, 9, '0'))
        }
        setShowSpinner(true);
        logic.sendAuthentioncationSms(identityNumber, mobilePhone, () => {
            setShowSpinner(false);
            alert('מסרון עם קוד כניסה חד פעמי נשלחה למכשירך');
            setShouldHaveSmsCode(true);
            setSmsSentNotification(true);
            setTimeout(()=>{setSmsSentNotification(false)}, 3 * 1000);
        });
    }

    return(
        <div>
            <Loading isOpen={showSpinner}/>
            <Card className="mbcard-3">
                <CardBody>
                    {!props.authenticated && props.role === 'Unknown' ? 
                        <Alert color="danger">משתמש לא מוכר</Alert>
                    :
                    <>
                        <h4 className="card-title">אימות משתמש על ידי SMS</h4>
                        <div className="col-sm-4">
                            <Label for="identityNumber">תעודת זהות</Label>
                            <Input type="text" className="col-sm-4" name="identityNumber" id="identityNumber" value={identityNumber} onChange={(e) => setIdentityNumber(e.target.value)} placeholder="תעודת זהות"/>
                        </div>
                        <div className="col-sm-4">
                            <Label for="identityNumber">מספר סלולרי</Label>
                            <Input type="text" className="col-sm-4" name="mobilePhone" id="mobilePhone" value={mobilePhone} onChange={(e) => setMobilePhone(e.target.value)} placeholder="מספר סלולרי"/>
                        </div>
                        {shouldHaveSmsCode ? 
                        <div className="col-sm-4">
                            <Label for="identityNumber">קוד אימות</Label>
                            <Input type="text" className="col-sm-4" name="code" id="code" value={smsCode} onChange={(e) => setSmsCode(e.target.value)} placeholder="קוד האימות"/>
                        </div>
                        : null}

                        {props.role === 'UnAuthenticatedCandidate' ? <Alert color="danger">פג תוקף אישור הכניסה למערכת, אנא הזדהה מחדש.</Alert> : null}

                        <div style={{marginTop:'10px'}}>
                            {shouldHaveSmsCode ? <Button style={{marginRight:'20px'}} color="secondary" onClick={() => resend()}><FontAwesome name="redo"/> שלח מחדש</Button> : null}
                            <Button style={{marginRight:'20px'}}  color="primary" onClick={() => validate()}><FontAwesome name="check"/> אישור</Button>
                        </div>
                        <div style={{clear:'both'}}></div>
                        {smsSentNotification ? <Alert color="info" className="col-sm-6" style={{margin:'20px auto auto auto'}}>הודעת SMS נשלחה למספר הטלפון שציינת. אנא הזמן את הקוד שקיבלת</Alert> : null }

                        {error ? <Alert color="danger" className="col-sm-6" style={{margin:'20px auto auto auto'}}>{error}</Alert> : null}
                    </>}
                </CardBody>
            </Card>
        </div>
    );
}

export default Sms;